import React, { useEffect } from "react";
import Campaignbar from "../../components/Campaigns/Campaignbar";
import CampaignMain from "../../components/Campaigns/CampaignMain";
import MessageTemplateMain from "../../components/Templates/MessageTemplateMain";
import { useParams } from "react-router-dom";

type Props = { setShowExpiredAlert: any };

const Campaigns = (props: Props) => {
  const path = window.location.pathname;
  // console.log(path);
  // const { id } = useParams();
  // console.log(id);

  const [activePath, setActivePath] = React.useState(path.split("/")[2]);

  useEffect(() => {
    setActivePath(path.split("/")[2]);
  }, [path]);
  return (
    <div className="flex h-full min-h-0 w-full flex-col md:flex-row">
      <Campaignbar />
      <div className="min-w-0 flex-1 overflow-auto p-4">
        {activePath === "list" ? <CampaignMain setShowExpiredAlert={props.setShowExpiredAlert}/> : <MessageTemplateMain />}
      </div>
    </div>
  );
};

export default Campaigns;
